import request from '@/utils/request'
// 商铺分类列表
export function shopClassifyList(params) {
  return request({
    url: '/mchtPlat/list',
    method: 'post',
    params
  })
}
// 创建商铺分类
export function createShopClassify(params) {
  return request({
    url: '/mchtPlat/create',
    method: 'post',
    data: params
  })
}
// 删除商铺分类
export function deleteShopClassify(params) {
  return request({
    url: '/mchtPlat/delete',
    method: 'post',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/shopClassify.js